// Expose jQuery globally for legacy plugins (jQuery UI, Select2, etc.)

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;
globalThis.jQuery = jquery;
globalThis.$ = jquery;

// Select2 factory initialization
import select2 from 'select2';
select2(window.$);

// Initialize select2 on page load and Turbo navigation
function initSelect2() {
  window.$('select.custom-select').select2();
}

window.$(initSelect2);
document.addEventListener('turbo:load', initSelect2);
